export const GetUserInfo = 'GetUserInfo';
// Mark : 키
export const USER_QUERY_KEYS = {
  list: ['user', 'list'],
  info: ['user', 'info'],
};
